import React, { useState, useEffect } from 'react';
import '../AdminManager.css';

function ServiceManager() {
  const [services, setServices] = useState([]);
  const [categories, setCategories] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingService, setEditingService] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    category: '',
    price: '',
    features: [],
    isActive: true,
    isFeatured: false,
  });
  const [featureInput, setFeatureInput] = useState('');

  useEffect(() => {
    fetchServices();
    fetchCategories();
  }, []);

  const fetchServices = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/services/all', {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      setServices(data);
    } catch (error) {
      console.error('Error fetching services:', error);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await fetch('/api/categories');
      const data = await response.json();
      setCategories(data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');

    try {
      const url = editingService
        ? `/api/services/${editingService.id}`
        : '/api/services';
      const method = editingService ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        fetchServices();
        resetForm();
      }
    } catch (error) {
      console.error('Error saving service:', error);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Είστε σίγουροι;')) return;

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/services/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.ok) {
        fetchServices();
      }
    } catch (error) {
      console.error('Error deleting service:', error);
    }
  };

  const handleEdit = (service) => {
    setEditingService(service);
    setFormData({
      title: service.title,
      description: service.description,
      category: service.category?.id || service.categoryId,
      price: service.price || '',
      features: Array.isArray(service.features) ? [...service.features] : [],
      isActive: service.isActive !== undefined ? service.isActive : true,
      isFeatured: service.isFeatured !== undefined ? service.isFeatured : false
    });
    setShowForm(true);
    setFeatureInput('');
  };

  const addFeature = () => {
    if (featureInput.trim()) {
      setFormData({
        ...formData,
        features: [...formData.features, featureInput.trim()],
      });
      setFeatureInput('');
    }
  };

  const removeFeature = (index) => {
    setFormData({
      ...formData,
      features: formData.features.filter((_, i) => i !== index),
    });
  };

  const editFeature = (index, newValue) => {
    const updatedFeatures = [...formData.features];
    updatedFeatures[index] = newValue;
    setFormData({
      ...formData,
      features: updatedFeatures,
    });
  };

  const resetForm = () => {
    setFormData({
      title: '',
      description: '',
      category: '',
      price: '',
      features: [],
      isActive: true,
      isFeatured: false,
    });
    setEditingService(null);
    setShowForm(false);
    setFeatureInput('');
  };

  return (
    <div className="manager-container">
      <div className="manager-header">
        <h1 className="page-title">Υπηρεσίες</h1>
        <button
          className="btn btn-primary"
          onClick={() => setShowForm(!showForm)}
        >
          {showForm ? 'Ακύρωση' : '+ Νέα Υπηρεσία'}
        </button>
      </div>

      {showForm && (
        <div className="form-card">
          <h2>{editingService ? 'Επεξεργασία Υπηρεσίας' : 'Νέα Υπηρεσία'}</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Τίτλος *</label>
              <input
                type="text"
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                required
              />
            </div>

            <div className="form-group">
              <label>Περιγραφή *</label>
              <textarea
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                rows="4"
                required
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Κατηγορία *</label>
                <select
                  value={formData.category}
                  onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                  required
                >
                  <option value="">Επιλέξτε κατηγορία</option>
                  {categories.map((cat) => (
                    <option key={cat._id} value={cat._id}>
                      {cat.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Τιμή</label>
                <input
                  type="text"
                  value={formData.price}
                  onChange={(e) => setFormData({ ...formData, price: e.target.value })}
                  placeholder="π.χ. Από €500"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Χαρακτηριστικά</label>
              <div className="features-input">
                <input
                  type="text"
                  value={featureInput}
                  onChange={(e) => setFeatureInput(e.target.value)}
                  placeholder="Προσθέστε χαρακτηριστικό"
                  onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), addFeature())}
                />
                <button type="button" className="btn btn-secondary" onClick={addFeature}>
                  Προσθήκη
                </button>
              </div>
              <ul className="features-list">
                {formData.features.map((feature, index) => (
                  <li key={index}>
                    <input
                      type="text"
                      value={feature}
                      onChange={(e) => editFeature(index, e.target.value)}
                      className="feature-edit-input"
                    />
                    <button type="button" onClick={() => removeFeature(index)}>×</button>
                  </li>
                ))}
              </ul>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={formData.isActive}
                    onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                  />
                  Ενεργό
                </label>
              </div>
              <div className="form-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={formData.isFeatured}
                    onChange={(e) => setFormData({ ...formData, isFeatured: e.target.checked })}
                  />
                  Προτεινόμενο
                </label>
              </div>
            </div>

            <div className="form-actions">
              <button type="submit" className="btn btn-primary">
                {editingService ? 'Ενημέρωση' : 'Δημιουργία'}
              </button>
              <button type="button" className="btn btn-outline" onClick={resetForm}>
                Ακύρωση
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="items-list">
        {services.map((service) => (
          <div key={service.id} className="item-card">
            <div className="item-content">
              <h3>{service.title}</h3>
              <p className="item-description">{service.description}</p>
              <div className="item-meta">
                <span className="category-badge">
                  {service.category?.icon} {service.category?.name}
                </span>
                {service.price && <span className="price-badge">💰 {service.price}</span>}
                <span className={`status-badge ${service.isActive ? 'active' : 'inactive'}`}>
                  {service.isActive ? 'Ενεργό' : 'Ανενεργό'}
                </span>
              </div>
            </div>
            <div className="item-actions">
              <button className="btn-icon" onClick={() => handleEdit(service)}>
                ✏️
              </button>
              <button className="btn-icon" onClick={() => handleDelete(service.id)}>
                🗑️
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ServiceManager;
